import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import { movies } from '@/mocks/movies';
import HeroCarousel from './components/HeroCarousel';
import CategoryQuickLinks from './components/CategoryQuickLinks';
import MovieSection from './components/MovieSection';

export default function Home() {
  const latest = [...movies].sort((a, b) => b.year - a.year).slice(0, 10);
  const hot = [...movies].sort((a, b) => b.heat - a.heat).slice(0, 10);

  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main>
        <HeroCarousel />
        <CategoryQuickLinks />

        <MovieSection
          title="最新上线"
          subtitle="新鲜出炉的影视剧集，第一时间为你更新"
          icon="ri-time-line"
          movies={latest}
          linkTo="/category"
          linkLabel="更多最新"
        />

        <div className="bg-background-100/60">
          <MovieSection
            title="热门推荐"
            subtitle="全网高热度精选，众多影迷正在关注"
            icon="ri-fire-line"
            movies={hot}
            linkTo="/category"
            linkLabel="更多热门"
            showHeat
          />
        </div>

        <section className="mx-auto px-4 py-12 md:px-10 md:py-16">
          <div className="grid grid-cols-1 gap-6 rounded-lg bg-primary-50 p-6 ring-1 ring-primary-100 md:grid-cols-3 md:gap-8 md:p-10">
            <div className="md:col-span-1">
              <h2 className="font-heading text-xl font-bold text-foreground-950 md:text-2xl">
                关于伊人在线
              </h2>
              <p className="mt-3 text-sm leading-relaxed text-foreground-700">
                一个为影视爱好者打造的精选内容平台，帮你快速找到想看的电视剧与电影。
              </p>
              <Link
                to="/about"
                className="mt-5 inline-flex items-center gap-1 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
              >
                了解更多
                <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
            <div className="grid grid-cols-1 gap-4 sm:grid-cols-3 md:col-span-2">
              <div className="rounded-lg bg-background-50 p-5 ring-1 ring-background-200/70">
                <i className="ri-film-line text-2xl text-primary-600"></i>
                <p className="mt-3 font-heading text-2xl font-extrabold text-foreground-950">
                  {movies.length}+
                </p>
                <p className="mt-1 text-sm text-foreground-600">精选影视作品</p>
              </div>
              <div className="rounded-lg bg-background-50 p-5 ring-1 ring-background-200/70">
                <i className="ri-calendar-check-line text-2xl text-accent-600"></i>
                <p className="mt-3 font-heading text-2xl font-extrabold text-foreground-950">
                  每日
                </p>
                <p className="mt-1 text-sm text-foreground-600">更新最新影视信息</p>
              </div>
              <div className="rounded-lg bg-background-50 p-5 ring-1 ring-background-200/70">
                <i className="ri-filter-3-line text-2xl text-secondary-600"></i>
                <p className="mt-3 font-heading text-2xl font-extrabold text-foreground-950">
                  多维
                </p>
                <p className="mt-1 text-sm text-foreground-600">筛选与快捷搜索</p>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}